
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 1.7L15.3 0 8.5 6.8 1.7 0 0 1.7l6.8 6.8L0 15.3 1.7 17l6.8-6.8 6.8 6.8 1.7-1.7-6.8-6.8L17 1.7z","fill":"#F47B36"}})])
          )
        }
      }
    